// https://tanstack.com/router/latest/docs/framework/react/guide/external-data-loading#error-handling-with-tanstack-query

import {useQueryErrorResetBoundary} from '@tanstack/react-query';
import {useRouter} from '@tanstack/react-router';
import {useCallback, useEffect} from 'react';

import {AppError} from '../../utils/errors';

import {MainErrorScreen} from './MainErrorScreen';

import type {ErrorRouteComponent} from '@tanstack/react-router';

type Props = React.ComponentProps<ErrorRouteComponent>;
export function RootQueryErrorScreen({error, reset}: Props): React.JSX.Element {
  const router = useRouter();
  const queryErrorResetBoundary = useQueryErrorResetBoundary();

  useEffect(() => {
    queryErrorResetBoundary.reset();
  }, [queryErrorResetBoundary]);

  const handleRetry = useCallback(() => {
    reset();
    router.invalidate();
  }, [reset, router]);

  const kind = error instanceof AppError ? error.kind : 'critical';
  const title = error instanceof AppError ? error.title : undefined;

  return (
    <MainErrorScreen
      error={error}
      handleRetry={handleRetry}
      kind={kind}
      title={title}
    />
  );
}

RootQueryErrorScreen.displayName = 'RootQueryErrorScreen';
